export const STEPS = [
    {
        icon: "fad fa-comment-text",
        title: "Step 1: Prompt",
        description: "Tell us what you want to find.",
        videoSrc: "/videos/tutorial/step1.webm"
    },
    {
        icon: "fad fa-sliders-simple",
        title: "Step 2: Tune",
        description: "Adjust sliders to change the number of objects found.",
        videoSrc: "/videos/tutorial/step2.webm"
    },
    {
        icon: "fad fa-magnifying-glass",
        title: "Step 3: Review",
        description: "Preview the results on all of your data and adjust as needed.",
        videoSrc: "/videos/tutorial/step3.webm"
    },
    {
        icon: "fad fa-rocket",
        title: "Step 4: Deploy",
        description: "Deploy your model on the cloud or on the edge.",
        videoSrc: "/videos/tutorial/step4.webm"
    }
];
